/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import {
  applyBlockAccountOptimistic,
  isContentBlockingAffectedQuery,
  reconcileContentBlockingResponse,
} from '../../helpers/content-blocking.js';
import type { BlockAccountResponse, BlockAccountVars } from '../openapi-types.gen.js';

export type { BlockAccountResponse, BlockAccountVars } from '../openapi-types.gen.js';

export const useBlockAccount = createMutationHook<BlockAccountVars, BlockAccountResponse, unknown>({
  specName: 'useBlockAccount',
  path: '/v1/blocked-accounts/{userId}',
  method: 'PUT',
  resolveUrl: (vars: BlockAccountVars) => `/v1/blocked-accounts/${vars.userId}`,
  
  parseResponse: (raw: unknown): BlockAccountResponse => raw as BlockAccountResponse,
  optimistic: [
    {
      queryKey: [],
      predicate: isContentBlockingAffectedQuery,
      
      apply: (prev: unknown, vars: BlockAccountVars, queryKey: readonly unknown[]) =>
        applyBlockAccountOptimistic(prev, vars, queryKey),
    }, {
    queryKey: ['blocked-accounts', 'detail'],
    apply: (prev: any, vars: BlockAccountVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['blocked-accounts', 'list'],
    apply: (prev: any, vars: BlockAccountVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  viewerRelationship: {"kind":"block","targetArg":"userId","active":true} as const,
  onSuccess: (response: BlockAccountResponse, vars: BlockAccountVars, queryClient) =>
    reconcileContentBlockingResponse(queryClient, response, vars),
});
